import GeneralForm from "components/GeneralForm"
import { validate } from "components/validateGeneralForm"
import { useEffect, useMemo, useState } from "react"
import { Button, Modal, ModalBody } from "reactstrap"

export default function ModalItem({ config, onClosed, onSave }) {
  const [data, setData] = useState({})

  useEffect(() => {
    if (config?.modo == 'edit')
      setData(data => ({
        ...data,
        ...config.data,
        valorTotal: config.data.quantidadeContratada * config.data.precoUnitario
      }))
    else
      setData({})
  }, [config])

  const formConfig = useMemo(() => {
    if (!config)
      return []

    return [
      [
        {
          name: 'where',
          type: 'view',
          component: () => {
            return (
              <>
                <label>Criar abaixo de</label>
                <div className="mb-4 form-control" style={{ height: 'auto' }}>{config.pai.descricao}</div>
              </>
            )
          },
        },
        { name: "codigo", label: 'Código', type: "text", required: true, colspan: 6, disabled: config.modo == 'edit' },
        { name: "descricao", label: 'Descrição', type: "text", required: true, colspan: 12 },
        {
          name: "unidade",
          label: 'Unidade',
          type: "combo",
          required: true,
          colspan: 3,
          options: [
            { "value": "h", "label": "Horas" }, 
            { "value": "l", "label": "Litros" }, 
            { "value": "mês", "label": "Meses" }, 
            { "value": "m", "label": "Metros" }, 
            { "value": "m²", "label": "Metros Quadrados" }, 
            { "value": "prancha", "label": "Pranchas" }, 
            { "value": "un", "label": "Unidades" }
          ],
          showDefault: true
        },
        { name: "precoUnitario", label: 'Valor Unitário', type: "decimal", required: true, colspan: 3 },
        { name: "quantidadeContratada", label: 'Quantidade', type: "decimal", required: true, colspan: 3 },
        { name: "valorTotal", label: 'Valor Total', type: "decimal", required: true, colspan: 3, disabled: true },
      ]
    ]
  }, [config])

  const handleChange = (name, value) => {
    if (name == 'quantidadeContratada') {
      setData(data => ({ ...data, quantidadeContratada: value, valorTotal: (data.precoUnitario || 0) * (value || 0) }))
    } else if (name == 'precoUnitario') {
      setData(data => ({ ...data, precoUnitario: value, valorTotal: (value || 0) * (data.quantidadeContratada || 0) }))
    } else {
      setData(data => ({ ...data, [name]: value }))
    }
  }

  const handleSubmit = e => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData(data => ({ ...data, errors }))
      // erros foram encontrados
      return
    }

    onSave && onSave(config.pai.id, config.modo, data)
  }

  return (
    <Modal isOpen={!!config} onClosed={onClosed} size="lg">
      <ModalBody>
        {config && (
          <>
            <h2>Cadastro de Item</h2>
            <hr />
            <form onSubmit={handleSubmit}>
              <GeneralForm
                data={data}
                onChange={handleChange}
                config={formConfig} />
              <div className="text-right">
                <Button type="submit" color="primary">Salvar</Button>
                <Button type="button" onClick={onClosed} color="secondary">Cancelar</Button>
              </div>
            </form>
          </>
        )}
      </ModalBody>
    </Modal>
  )
}